<section class="container">
  <mat-icon *ngIf="data?.iconType === IconType.Success" class="icon-success mat-green">
    check_circle
  </mat-icon>
  <img *ngIf="data?.iconType === IconType.Warning" class="icon-warning"
    src="assets/errors/warning-sign.png"
    alt="Warning sign"
  />

  <h2 class="title">{{ data?.title }}</h2>

  <p [innerHTML]="data?.body | safeHtml"></p>

  <footer class="footer">
    <button
      mat-flat-button
      color="primary"
      (click)="onActionClick()"
      class="footer__action"
    >
      {{ data?.buttonLabel }}
    </button>
  </footer>
</section>
